import React from 'react';
import { motion } from 'framer-motion';
import { Mail, MapPin } from 'lucide-react';

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-28 md:py-36 px-5 md:px-10 bg-surface-muted"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          <span className="font-pixel text-[11px] tracking-[0.25em] uppercase text-brand">
            Get in Touch
          </span>
          <h2
            data-testid="contact-heading"
            className="mt-4 text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tightest leading-[1.02]"
          >
            Say hello. We read every message.
          </h2>
        </motion.div>

        <div className="mt-14 grid md:grid-cols-2 gap-5 max-w-4xl">
          <motion.a
            href="mailto:team@kingswake.co.in"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            data-testid="contact-email-card"
            className="group relative p-8 rounded-3xl bg-white border border-black/5 hover:border-brand/30 hover:-translate-y-1 hover:shadow-[0_20px_50px_-20px_rgba(229,9,20,0.25)] transition-all"
          >
            <div className="w-12 h-12 rounded-2xl bg-brand/10 text-brand flex items-center justify-center group-hover:bg-brand group-hover:text-white transition-colors">
              <Mail size={22} strokeWidth={1.8} />
            </div>
            <div className="mt-5 font-pixel text-[10px] tracking-[0.2em] uppercase text-ink/40">
              Email us
            </div>
            <div className="mt-1.5 text-xl md:text-2xl font-semibold text-ink">
              team@kingswake.co.in
            </div>
            <div className="mt-2 text-sm text-ink/50">
              Partnerships, press, support — we'll respond within 48 hours.
            </div>
          </motion.a>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.08 }}
            data-testid="contact-address-card"
            className="relative p-8 rounded-3xl bg-white border border-black/5"
          >
            <div className="w-12 h-12 rounded-2xl bg-brand/10 text-brand flex items-center justify-center">
              <MapPin size={22} strokeWidth={1.8} />
            </div>
            <div className="mt-5 font-pixel text-[10px] tracking-[0.2em] uppercase text-ink/40">
              Our Address
            </div>
            <div className="mt-1.5 text-xl md:text-2xl font-semibold text-ink">
              Punjab, India — 141412
            </div>
            <div className="mt-2 text-sm text-ink/50">
              King's Wake Digital Private Limited
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
